<template>
<div>
    <div class="mcc-page-header">
        <div class="mu-d-flex mu-flex-column  mu-w-100">
            <div class="mu-d-flex mu-justify-content-between mu-align-items-center mu-flex-wrap">
                <section class="mu-d-flex">
                    <h1 class="mu-mb-00">External system API</h1>
                    <details class="mcc-popover mcc-popover--bottom-end">
                        <summary class="mcc-button mcc-button--icon-only ">
                            <mcc-icon name="help" aria-hidden="true"></mcc-icon>
                        </summary>
                        <div class="mcc-popover__content">

                            <p class="mu-mb-00">
                                {{ helpText.title }}
                                <a :href="helpText.url" target="_blank">Read more...</a>
                            </p>
                        </div>
                    </details>
                </section>
                <section>
                    <div role="group" class="mcc-button-group">
                        <button class="mcc-button mcc-button--outline" id="exportBtn" @click="exportFiles()" title="Export">
                            <mcc-icon name="export" aria-hidden="true"></mcc-icon><span class="mcc-button__label">Export</span>
                        </button>
                    </div>
                </section>
            </div>
        </div>
    </div>
    <div class="mcc-container-fluid card-padding">
        <div>
            <nav aria-label="breadcrumb">
                <ol class="mcc-breadcrumb">
                    <li>Integrate</li>
                    <li class="linkCode">
                        <a class="linkCode" @click="redirectToList()">External systems</a>
                    </li>
                    <li class="linkCode">
                        <router-link class="linkCode" :to="CONTEXT_PATH + '/integrate/externalsystems/' + externalSystemId">{{externalSystem.name}}</router-link>
                    </li>
                    <li aria-current="page">{{apiName}}</li>
                </ol>
            </nav>
        </div>
        <div class="mcc-card mu-p-06">
            <div class="mcc-row" v-show="!fetchCall">
                <div class="mcc-col colSpinner">
                    <div class="spinner-overlay">
                        <div class="spinner-background"></div>
                        <div class="spinner-flex">
                            <svg viewBox="0 0 50 50" class="mcc-spinner" animated="" style="width: 48px; height: 48px; ">
                                <circle class="mcc-spinner__track" cx="25" cy="25" r="20" fill="none" stroke-width="5"></circle>
                                <circle cx="25" cy="25" r="20" fill="none" stroke-width="5"></circle>
                            </svg>
                        </div>
                    </div>

                </div>

            </div>

            <div class="mcc-row" v-show="fetchCall">
                <div class="mcc-col">
                    <div style="position:relative">
                        <div v-show="!updateCallAPI" class="spinner-overlay">
                            <div class="spinner-background"></div>
                            <div class="spinner-flex">
                                <svg viewBox="0 0 50 50" class="mcc-spinner" animated="" style="width: 48px; height: 48px; ">
                                    <circle class="mcc-spinner__track" cx="25" cy="25" r="20" fill="none" stroke-width="5"></circle>
                                    <circle cx="25" cy="25" r="20" fill="none" stroke-width="5"></circle>
                                </svg>
                            </div>
                        </div>
                        <div>
                            <div class="mcc-col mcc-col-xs-12 mcc-col-md-12 mcc-col-sm-12" v-show="!hasActiveConnection">
                                <mcc-alert role="alert" class="mcc-alert mcc-alert--warning mcc-alert--compact" color="warning">
                                    <mcc-icon name="error" aria-hidden="true"></mcc-icon>
                                    <span>
                                        You must choose an active connection.
                                    </span>
                                </mcc-alert>

                            </div>

                            <div class="mcc-col mcc-col-xs-12 mcc-col-md-12 mcc-col-sm-12">
                                <mcc-alert role="alert" class="mcc-alert mcc-alert--warning mcc-alert--compact" id="externalSystemReadOnly" v-show="isReadOnly" color="warning">
                                    <mcc-icon name="error" aria-hidden="true"></mcc-icon>
                                    <span>
                                        <strong>Warning!</strong>
                                        <br />{{readOnlyMsg}}
                                        <br />
                                    </span>
                                </mcc-alert>
                            </div>

                            <div class="mcc-card ">
                                    
                                    <form novalidate ref="externalSystemAPIForm" id="#formId" @submit.prevent="saveExternalSystemAPI()">
                                        <div>
                                            <div class="mcc-card__header mu-mb-05">
                                                <h2 class="mcc-card__title">{{ connectionName }}</h2>
                                            </div>
                                            <div class="mcc-card__body">
                                                <div class="mcc-row">
                                                    <div class="mcc-col">
                                                        <div class="mfc-input-wrapper mfc-form-input-wrapper--width mu-d-block mfc-form-input-container mu-mb-03">
                                                            <label for="nameField" class="mfc-label--required">Name</label>
                                                            <input type="text" id="nameField" name="nameField" required="" placeholder="Name" maxlength="50" :disabled="isReadOnly" ref="name" :value="dto.name" :pattern="nameRegex" @change="updateName($event)">

                                                        </div>

                                                        <div class="mfc-input-wrapper mfc-form-input-wrapper--width mu-d-block mfc-form-input-container mu-mb-03" v-show="dto.connectionType=='REST'">
                                                            <label for="helpId">Rest API help documentation</label>
                                                            <input type="text" id="helpId" name="helpName" placeholder="Rest API help documentation" maxlength="100" :disabled="isReadOnly" @change="dto.helpURL = $event.target.value" ref="dto.helpId" :value="dto.helpURL" :pattern="helpDocumentationES">

                                                        </div>

                                                        <div class="mfc-slim-select-wrapper mfc-form-input-wrapper--width  mu-mb-03" v-show="dataLoaded">
                                                            <label for="activeConnection" class=" mu-mb-00">Active
                                                                Connection</label>
                                                            <select class="mfc-slim-select" :disabled="isReadOnly" @change="dto.activeConnectionId = $event.target.value" ref="activeConnection" name="activeConnection" id="activeConnection">
                                                                <option v-for="(app,key) in connectionList" :selected="activeConnection === app.id" :key="key" :value="app.id">{{app.name}}</option>
                                                            </select>
                                                        </div>
                                                        <div class="mu-d-flex mu-justify-content-end  mu-mt-06" v-show="!isReadOnly">
                                                            <div role="group" class="mcc-button-group mcc-button-group--spaced">
                                                            <button class="mcc-button mcc-button--soft-danger" id="deleteBtn" type="button" dialog="deleteExternalSystemAPI" title="Delete" @click="openDeleteDialog()">
                                                                <mcc-icon name="trash" aria-hidden="true"></mcc-icon><span class="mcc-button__label">Delete</span>
                                                            </button>
                                                            <button class="mcc-button mcc-button--success" title="Save" id="saveBtn" type="submit" >
                                                                <mcc-icon name="save" aria-hidden="true"></mcc-icon><span class="mcc-button__label">Save</span>
                                                            </button>
                                                        </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </form>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="mcc-row mu-mt-05" v-show="fetchCall">

                <div class="mcc-col mcc-col-lg-6">

                    <div class="mcc-card fullHeightCard">
                        <div>
                            <div v-show="!updateCallConnection" class="spinner-overlay">
                                <div class="spinner-background"></div>
                                <div class="spinner-flex">
                                    <svg viewBox="0 0 50 50" class="mcc-spinner" animated="" style="width: 48px; height: 48px; ">
                                        <circle class="mcc-spinner__track" cx="25" cy="25" r="20" fill="none" stroke-width="5"></circle>
                                        <circle cx="25" cy="25" r="20" fill="none" stroke-width="5"></circle>
                                    </svg>
                                </div>
                            </div>
                            <div>
                                <div class="mcc-card__header mu-d-flex mu-justify-content-between mu-align-items-start mu-flex-wrap" v-show="!isReadOnly">
                                    <div>
                                        <h2 class="mcc-card__title">Connections</h2>
                                    </div>
                                    <div class="mu-d-flex">

                                        <button class="mcc-button mcc-button--sm mcc-button--soft-primary" id="addConnectionBtn" title="Add connection" @click="addConnection()">
                                            <mcc-icon name="plus" aria-hidden="true"></mcc-icon><span class="mcc-button__label">Add Connection</span>
                                        </button>

                                    </div>
                                </div>
                                <div class="mcc-card__body mu-mt-05">
                                    <mcc-data-table ref="connectionListTable" id="connectionListTableId"></mcc-data-table>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                    <div class="mcc-col mcc-col-lg-6">
                    <div class="mcc-card  fullHeightCard">
                        <div v-show="!updateCallAdapter" class="spinner-overlay">
                                <div class="spinner-background"></div>
                                <div class="spinner-flex">
                                    <svg viewBox="0 0 50 50" class="mcc-spinner" animated="" style="width: 48px; height: 48px; ">
                                        <circle class="mcc-spinner__track" cx="25" cy="25" r="20" fill="none" stroke-width="5"></circle>
                                        <circle cx="25" cy="25" r="20" fill="none" stroke-width="5"></circle>
                                    </svg>
                                </div>
                            </div>
                        <Drawer ref="customFilter" @reset-filter="resetFilter" @apply-filter="submitDialog" title="Adapter List Filters">
                         
                                <section>
                                    <div>
                                        <div class="mcc-row">
                                            <div class="mcc-col">
                                                <form id="formIdd">
                                                <div>
                                                    <div class="mfc-input-wrapper mfc-form-input-container mu-mb-03">
                                                        <label for="filterName" class="mu-mb-00">Name</label>
                                                        <input type="text" name="filter-name" maxlength="50" id="filterName" :pattern="nameRegex" :value="filterNameRef" @change="filterNameRef = $event.target.value">
                                                    </div>
                                                    <div v-show="adapterType=='REST'">

                                                        <div class="mfc-slim-select-wrapper mu-mb-03">
                                                            <label for="methodSelectId1" class="mu-mb-00">Method</label>
                                                            <select :disabled=isReadOnly required @change="selectedMethodRef = $event.target.value" ref="selectedMethodRef" name="methodSelectId1" id="methodSelectId1" class="mfc-slim-select">
                                                                <option value></option>
                                                                <option :selected="selectedMethodRef === 'GET'" value="GET">GET</option>
                                                                <option :selected="selectedMethodRef === 'PUT'" value="PUT">PUT</option>
                                                                <option :selected="selectedMethodRef === 'POST'" value="POST">POST</option>
                                                                <option :selected="selectedMethodRef === 'PATCH'" value="PATCH">PATCH</option>
                                                                <option :selected="selectedMethodRef === 'DELETE'" value="DELETE">DELETE</option>
                                                            </select>
                                                        </div>

                                                    </div>
                                                    <div v-show="adapterType=='Database'">

                                                        <div class="mfc-slim-select-wrapper mu-mb-03">
                                                            <label for="methodSelectId" class="mu-mb-00">Method</label>
                                                            <select :disabled=isReadOnly required @change="selectedMethodRef = $event.target.value" ref="selectedMethodRef" name="methodSelectId" id="methodSelectId" class="mfc-slim-select">
                                                                <option value></option>
                                                                <option :selected="selectedMethodRef === 'SELECT'" value="SELECT">SELECT</option>
                                                                <option :selected="selectedMethodRef === 'UPDATE'" value="UPDATE">UPDATE</option>
                                                            </select>
                                                        </div>
                                                    </div>
                                                </div>
                                            </form>
                                            </div>
                                        </div>

                                    </div>
                                </section>
                           
                        </Drawer>

                        <div class="mcc-card__body">
                            <div class="mu-d-flex mu-justify-content-between mu-align-items-start mu-flex-wrap mu-mb-05">
                                <h4 class="mu-fw-semi-bold">{{ adapterHeader }}</h4>
                              
                                <div class="mu-d-flex mu-justify-content-end">
                                    <div class="mcc-button-group mcc-button-group--spaced">
                                    <button class="mcc-button mcc-button--sm mcc-button--soft-primary" v-show="!isReadOnly" :disabled="!hasActiveConnection" id="addAdapterBtn" title="Add adapter" @click="addAdapter()">
                                        <mcc-icon name="plus" aria-hidden="true"></mcc-icon><span class="mcc-button__label">Add Adapter</span>
                                    </button>
                                    <button class="mcc-button mcc-button--outline mcc-button--sm" @click="$refs.customFilter.open()">
                                        <mcc-icon name="filter" aria-hidden="true"></mcc-icon>
                                        <span class="mcc-button__label">Filters {{ filterCount > 0 ? '(' + filterCount + ')' : '' }}</span>
                                    </button>
                                </div>
                           
                            </div>
                        </div>
                            <mcc-data-table ref="adapterListTable" id="adapterListTableTableId"></mcc-data-table>
                       

                    </div>
                </div>
           
            </div>

        </div>
    </div>
    <div class="mcc-dialog-overlay">
        <dialog class="mcc-dialog mcc-dialog--danger mcc-dialog--xs" v-show="dataLoaded" color="danger" id="deleteExternalSystemAPI" ref="deleteExternalSystemAPI">
            <form novalidate>
                <section>
                    <div class="mcc-dialog__header">
                        <h2 class="h4">Delete API</h2>
                        <button type="button" class="mcc-button mcc-button--sm  mcc-button--ghost mcc-button--icon-only" @click="closeDeleteDialog()">
                        <mcc-icon name="close" aria-hidden="true"></mcc-icon>
                        <span class="mcc-button__label">Button</span>
                    </button>
                    </div>
                    <div class="mcc-dialog__body">
                        <div v-show="!hasActiveConnection">
                            Are you sure you want to delete this external system API?
                        </div>
                        <div v-show="hasActiveConnection">
                            Deleting this external system API will remove all the associated connections. Continue?
                        </div>
                    </div>
                    <div class="mcc-dialog__footer">
                        <div class="mcc-button-group mcc-button-group--spaced">
                            <button type="button" class="mcc-button mcc-button--outline" @click="closeDeleteDialog()">No</button>
                            <button type="button" class="mcc-button mcc-button--danger" @click="deleteExternalSystemAPI($event)">Yes</button>
                        </div>
                    </div>
                </section>
            </form>
        </dialog>
    </div>
</div>
</div>
</template>

<script>
import ExternalSystemAPI from "../../../services/ExternalSystemAPI";
import {
    EventBus
} from "../../../services/event-bus";
import constantMessages from "../../../messages";
import Table from "@advanced/component-mosaic-table";
import ImportExportAPI from "../../../services/ImportExportAPI";
import Utils from "@/script_utils";
import {
    handleFormValidation,
    validationMessages,
    displayErrorMessage
} from '@/formvalid.js';
import Drawer from '../../common/Drawer.vue';
export default {
    name: "ExternalSystemAPIEdit",
    components: {
        Drawer
    },
    data() {
        return {
            dto: {
                connectionType: "DATABASE",
                name: ""
            },
            externalSystem: {},
            updateCallAPI: true,
            nameRegex: constantMessages.PATTERNS["name"],
            CONTEXT_PATH: process.env.VUE_APP_CONTEXT_PATH,
            helpText: constantMessages.BREADCRUMB_HELP["externalsystemAPI.edit"],
            helpDocumentationES: constantMessages.PATTERNS["helpDocumentationES"],
            externalSystemId: this.$route.params.externalSystemId,
            apiId: this.$route.params.apiId,
            connectionType: [],
            showHelpText: false,
            fetchCall: true,
            activeConnection: null,
            hasActiveConnection: false,
            connectionList: [],
            currentPageSize: 10,
            connectionPageSize: 10,
            adaptersPageSize: 10,
            updateCallConnection: false,
            updateCallAdapter: false,
            connectionName: "",
            apiName: "",
            dataLoaded: false,
            adapterType: null,
            tableObj: null,
            adapterHeader: "",
            updateDialog: false,
            filterNameRef: "",
            filterName: "",
            selectedMethodRef: "",
            selectedMethod: "",
            tableData: [],
            tableDatas: [],
            filterActive: false,
            filterActives: false,
            filterData: [],
            filterCount: 0,
            filterDatas: [],
            filterCounts: 0,
            isReadOnly: false,
            activeConnection: null,
            methodSelectId: null,
            methodSelectId1: null,
            readOnlyMsg: constantMessages.MESSAGES["error.externalsystems.readonly"]
        };
    },
    mounted() {
        Utils.applyFixedHeaderConfiguration(this);

        let self = this;
        self.fetchCall = false;
        ExternalSystemAPI.getExternalSystemAPI(self.externalSystemId, self.apiId)
            .then(result => {
                if (result == null || result == "") {
                    self.$router.push(
                        self.CONTEXT_PATH + "/integrate/externalsystems"
                    );
                    EventBus.$emit('error-notification', {
                        "msg": "Error while fetching external system API"
                    });
                    return;
                }
                self.dto = result.externalSystemAPI;
                self.apiName = self.dto.name;

                self.dataLoaded = true;
                self.externalSystem = self.dto.externalSystem;
                self.isReadOnly = self.externalSystem.readOnly;
                self.hasActiveConnection = self.dto.activeConnectionId != null;
                if (self.hasActiveConnection) {
                    self.activeConnection = self.dto.activeConnectionId;
                }
                self.connectionList = result.connectionList;
                self.connectionType = result.importType;
                self.adapterType = result.connectionName;
                self.connectionName = result.connectionName + " API";
                self.adapterHeader = result.connectionName + " adapters"
                let pageTitle = constantMessages.PAGEHEADER_TITLE["menu.systemApi.details"] + " - " + self.apiName;
                EventBus.$emit("update-pageTitle", pageTitle);
            }).finally(function () {
                self.fetchCall = true;
                self.loadTables();

            });;

        this.activeConnection = new SlimSelect({
            select: '#activeConnection'
        });

        this.methodSelectId = new SlimSelect({
            select: '#methodSelectId'
        });
        this.methodSelectId1 = new SlimSelect({
            select: '#methodSelectId1'
        })
    },
    created() {

    },
    methods: {
        handleValidation() {
            let invalid = false;
            let self = this;
            if (!this.dto?.name) {
                displayErrorMessage($(self.$refs.name), constantMessages.MESSAGES["error.name.required"])
                self.$refs.name.classList.add("ms-is-invalid")
                invalid = true;
            }

            return invalid;
        },
        openDeleteDialog() {
            this.$refs.deleteExternalSystemAPI.show();
        },
        getFilterCount()
        {
            this.filterCount = 0;
            if (this.filterName != null && this.filterName != "") {
                this.filterCount++;
            }
            if (this.selectedMethod != null && this.selectedMethod != "") {
                this.filterCount++;
            }
        },
        submitDialog(e) {
            let form = $('#formIdd')
            if (!form[0].checkValidity()) {
                handleFormValidation(form, validationMessages);
                return;
            }
            this.filterName = this.filterNameRef;
            this.selectedMethod = this.selectedMethodRef != undefined ? this.selectedMethodRef : "";
            this.getFilterCount();
            if (this.adapterType == "REST") {
                this.initRestAdapterTable();
            } else if (this.adapterType == "Database") {
                this.initSQLAdaptersTable();
            } else {
                this.initFileAdaptersTable();
            }
            $('#formIdd').closest('#drawerOverlay').removeClass("mcc-drawer--open")
            $('#formIdd').closest('#drawerOverlay').addClass("mcc-drawer--closed")
        },
        filterRestAdapterList(filteredRows, filterValue) {
            return filteredRows.filter(function (h) {
                return (h.name.toLowerCase().includes(filterValue.toLowerCase()) || h.httpMethod.toLowerCase().includes(filterValue.toLowerCase()) || h.urlSuffix.toLowerCase().includes(filterValue.toLowerCase()));
            })
        },
        closeDialog() {
            this.updateDialog = false;
        },
        showDialog() {
            this.updateDialog = true;
        },
        showFilterDialog() {
            this.$refs.filterDialog.show();
        },
        updateConnectionList(filteredConnectionList) {
            this.filterData = filteredConnectionList;
            this.filterActive = true;
            this.initConnectionTable();
        },
        updateRestAdapterList(filteredRestAdapterList) {
            this.filterData = filteredRestAdapterList;
            this.filterActives = true;
            this.initRestAdapterTable();
        },
        resetSlimselect() {
            if (this.methodSelectId) {
                this.methodSelectId.setSelected('')
            }
            if (this.methodSelectId1) {
                this.methodSelectId1.setSelected('')
            }

        },
        resetFilter() {
            this.filterCount = 0;
            this.filterName = "";
            this.filterNameRef = "";
            this.selectedMethodRef = "";
            this.selectedMethod = "";
            this.resetSlimselect();
            if (this.adapterType == "REST") {
                this.initRestAdapterTable();
            } else if (this.adapterType == "Database") {
                this.initSQLAdaptersTable();
            } else {
                this.initFileAdaptersTable();
            }
        },
        async loadTables() {
            await this.$nextTick();
            let self = this;

            if (localStorage.getItem("APIList") === "APIList") {
                let filterRef = localStorage.getItem(
                    "DataTables_" + window.location.pathname + "_filterName"
                );
                let filterRefMethod = localStorage.getItem(
                    "DataTables_" + window.location.pathname + "_method-selectId"
                );

                let storedSize = localStorage.getItem("apiEditPageSize");
                if (storedSize != null && storedSize != "") {
                    this.adaptersPageSize = parseInt(storedSize);
                }

                localStorage.removeItem("APIList");
                localStorage.removeItem("apiEditPageSize");
                localStorage.removeItem("DataTables_" + window.location.pathname + "_filterName");
                localStorage.removeItem("DataTables_" + window.location.pathname + "_method-selectId");

                if (filterRef != null && filterRef != "") {
                    self.filterName = filterRef;
                    self.filterNameRef = filterRef;
                }

                if (filterRefMethod != null && filterRefMethod != "") {
                    self.selectedMethod = filterRefMethod;
                    self.selectedMethodRef = filterRefMethod;
                }
            }
            self.initConnectionTable();
            if (self.adapterType == "REST") {
                    self.initRestAdapterTable();
                } else if (self.adapterType == "Database") {
                    self.initSQLAdaptersTable();
                } else {
                    self.initFileAdaptersTable();
                }
        },
        saveExternalSystemAPI() {
            let form = $('#formId')
            let self = this;
            if (self.handleValidation()) {
                return;
            }
            // if (!form[0].checkValidity()) {
            //     return;
            // }
            self.updateCallAPI = false;
            ExternalSystemAPI.saveExternalSystemAPI(self.externalSystem.id, this.dto).then(response => {
                self.updateCallAPI = true;
                if (response.error) {
                    for (let k in response.messages) {
                        if (k == "name") {
                            displayErrorMessage($(self.$refs.name), constantMessages.MESSAGES[response.messages[k]])
                            self.$refs.name.classList.add("ms-is-invalid")
                        } else if (k == "description") {
                            displayErrorMessage($(self.$refs.description), constantMessages.MESSAGES[response.messages[k]])
                            self.$refs.description.classList.add("ms-is-invalid")
                        }
                    }
                } else {
                    self.apiName = self.dto.name;
                    self.hasActiveConnection = self.dto.activeConnectionId != null;
                    EventBus.$emit("success-notification", {
                        msg: constantMessages.MESSAGES[response.message]
                    });
                }
            });
        },
        initConnectionTable() {
            let self = this;
            self.updateCallConnection = false;
            let propObj = {};
            if (self.adapterType == "REST") {
                propObj = {
                    name: {
                        type: "string",
                        title: "Name",
                        template: '<a class="name-link" data-id="{{id}}">{{name}}</a>',
                        sortable: true
                    },
                    baseUrl: {
                        type: "string",
                        title: "Base URL",
                        sortable: false
                    },
                    authType: {
                        type: "string",
                        template: '<div  class="auth-link">{{authType}}</div>',
                        title: "Authentication method",
                        sortable: false
                    }
                };
            } else if (self.adapterType == "Database") {
                propObj = {
                    name: {
                        type: "string",
                        title: "Name",
                        template: '<a class="name-link" data-id="{{id}}">{{name}}</a>',
                        sortable: true
                    },
                    vendor: {
                        type: "string",
                        title: "Database vendor",
                        sortable: false
                    },
                    jdbcUrl: {
                        type: "string",
                        title: "JDBC URL",
                        sortable: false
                    }
                };
            } else {
                propObj = {
                    name: {
                        type: "string",
                        title: "Name",
                        template: '<a class="name-link" data-id="{{id}}">{{name}}</a>',
                        sortable: true
                    }
                };
            }
            if (this.tableObj != null) {
                this.connectionPageSize = this.tableObj.tableContext.store.state.pageSize;
            }
            // this.tableObj = new Table(document.getElementById("connectionListTableId"), {
            const filesTable = document.querySelector('#connectionListTableId');
            this.tableObj = window.tableFactory.create(filesTable, {
                bordered: true,
                striped: true,
                emptyTemplate: '<p class="text-center m-0">No connections found</p>',
                loadingTemplate: '<p class="text-center m-0">Loading...</p>',
                columnSearch: false,
                debounceTime: 1000,
                pageSize: self.connectionPageSize,
                fixedHeight:true,
                schema: {
                    properties: propObj
                },
                data: (
                    start,
                    limit,
                    sortHeader,
                    sortDirection,
                    fullTextQuery,
                    searchColumns
                ) => {
                    if (!self.filterActive) {
                        self.updateCallConnection = false;
                        if (self.tableObj != null) {
                            self.currentPageSize =
                                self.tableObj.tableContext.store.state.pageSize;
                        }
                        if (sortHeader == null) {
                            sortHeader = "name"
                        }
                        if (sortDirection == null) {
                            sortDirection = "asc"
                        }

                        let queryString =
                            "start=" +
                            start +
                            "&length=" +
                            self.currentPageSize +
                            "&sort=" +
                            sortHeader +
                            "&dir=" +
                            sortDirection
                        return ExternalSystemAPI.getExternalSystemsConnections(self.apiId, queryString).then(result => {
                            let responseData = {
                                totalCount: 0,
                                data: []
                            };
                            if (result.data != null) {
                                responseData.data = result.data;
                                responseData.data.forEach(function (obj, index) {
                                    // obj.activeConnectionName = '';
                                    // obj.activeConnectionId = '';
                                    // if (obj.activeConnection != null && obj.activeConnection != '') {
                                    //     obj.activeConnectionName = obj.activeConnection.name;
                                    //     obj.activeConnectionId = obj.activeConnection.id;
                                    // }
                                });
                            }
                            responseData.totalCount = result.page.totalElements;
                            if (result.data != null) {
                                responseData.data = result.data;
                            }
                            self.updateCallConnection = true;
                            self.tableData = responseData.data;
                            return responseData;
                        });
                    } else {
                        self.filterActive = false;
                        let responseData = {
                            totalCount: self.filterData.length,
                            data: self.filterData
                        };
                        self.updateCallConnection = true;
                        return responseData;
                    }
                },
                onPageChange: (start, limit) => {
                    self.updateTemplate();
                }
            });
        },
        initRestAdapterTable() {
            let self = this;
            self.updateCallAdapter = false;
            if (this.adaptersTableObj != null) {
                this.adaptersPageSize = this.adaptersTableObj.tableContext.store.state.pageSize;
            }
            // this.adaptersTableObj = new Table(document.getElementById("adapterListTableTableId"), {
            const filesTable = document.querySelector('#adapterListTableTableId');
            this.tableObj = window.tableFactory.create(filesTable, {
                bordered: true,
                striped: true,
                emptyTemplate: '<p class="text-center m-0">No adapters found</p>',
                loadingTemplate: '<p class="text-center m-0">Loading...</p>',
                columnSearch: false,
                debounceTime: 1000,
                pageSize: self.adaptersPageSize,
                fixedHeight:true,
                schema: {
                    properties: {
                        name: {
                            type: "string",
                            title: "Name",
                            template: '<a class="name-link" data-id="{{id}}">{{name}}</a>',
                            sortable: true
                        },
                        httpMethod: {
                            type: "string",
                            title: "Method",
                            sortable: true
                        },
                        urlSuffix: {
                            type: "string",
                            title: "Path",
                            sortable: false
                        }
                    }
                },
                data: (
                    start,
                    limit,
                    sortHeader,
                    sortDirection,
                    fullTextQuery,
                    searchColumns
                ) => {
                    if (!self.filterActives) {
                        self.updateCallAdapter = false;
                        if (self.adaptersTableObj != null) {
                            self.adaptersPageSize =
                                self.adaptersTableObj.tableContext.store.state.pageSize;
                        }
                        if (sortHeader == null) {
                            sortHeader = "name"
                        }
                        if (sortDirection == null) {
                            sortDirection = "asc"
                        }
                        let adapterName = self.filterName.trim();
                        let restMethod = self.selectedMethod.trim();
                        let queryString =
                            "start=" +
                            start +
                            "&length=" +
                            self.adaptersPageSize +
                            "&sort=" +
                            sortHeader +
                            "&dir=" +
                            sortDirection +
                            "&name=";
                        self.protectedType;

                        if (adapterName == null) {
                            adapterName = "";
                        }
                        if (restMethod == null) {
                            restMethod = "";
                        }
                        queryString += "&restadaptername=" + adapterName + "&restmethod=" + restMethod;

                        return ExternalSystemAPI.getRestAdapters(self.externalSystemId, self.apiId, queryString).then(result => {
                            let responseData = {
                                totalCount: 0,
                                data: []
                            };
                            responseData.totalCount = result.page.totalElements;
                            if (result.data != null) {
                                responseData.data = result.data;
                                responseData.data.forEach(function (obj, index) {
                                    let actionsObj = {
                                        deploymentAction: {
                                            hidden: obj.deploymentTime == null
                                        }
                                    }
                                    obj['actions'] = actionsObj;
                                })
                            }
                            self.updateCallAdapter = true;
                            self.tableDatas = responseData.data;
                            return responseData;
                        });
                    } else {
                        self.filterActives = false;
                        let responseData = {
                            totalCount: self.filterData.length,
                            data: self.filterData
                        };
                        self.updateCallAdapter = true;
                        return responseData;
                    }
                },
                onAfterDataLoad: (start, limit) => {
                    self.updateAdaptersTemplate();
                }
            });
        },
        initSQLAdaptersTable() {
            let self = this;
            self.updateCallAdapter = false;
            if (this.adaptersTableObj != null) {
                this.adaptersPageSize = this.adaptersTableObj.tableContext.store.state.pageSize;
            }
            const Table = document.querySelector('#adapterListTableTableId');
            this.adaptersTableObj = window.tableFactory.create(Table, {
                bordered: true,
                striped: true,
                emptyTemplate: '<p class="text-center m-0">No adapters found</p>',
                loadingTemplate: '<p class="text-center m-0">Loading...</p>',
                columnSearch: false,
                debounceTime: 1000,
                pageSize: self.adaptersPageSize,
                fixedHeight:true,
                schema: {
                    properties: {
                        name: {
                            type: "string",
                            title: "Name",
                            template: '<a class="name-link" data-id="{{id}}">{{name}}</a>',
                            sortable: true
                        },
                        sqlMethod: {
                            type: "string",
                            title: "Method",
                            sortable: true
                        },
                        sql: {
                            type: "string",
                            title: "SQL",
                            sortable: false
                        }
                    }
                },
                data: (
                    start,
                    limit,
                    sortHeader,
                    sortDirection,
                    fullTextQuery,
                    searchColumns
                ) => {
                    if (!self.filterActive) {
                        self.updateCallAdapter = false;
                        if (self.adaptersTableObj != null) {
                            self.adaptersPageSize =
                                self.adaptersTableObj.tableContext.store.state.pageSize;
                        }
                        if (sortHeader == null) {
                            sortHeader = "name"
                        }
                        if (sortDirection == null) {
                            sortDirection = "asc"
                        }
                        let adapterName = self.filterName.trim();
                        let sqlmethod = self.selectedMethod.trim();
                        let queryString =
                            "start=" +
                            start +
                            "&length=" +
                            self.adaptersPageSize +
                            "&sort=" +
                            sortHeader +
                            "&dir=" +
                            sortDirection +
                            "&name=";
                        self.protectedType;

                        if (adapterName == null) {
                            adapterName = "";
                        }
                        if (sqlmethod == null) {
                            sqlmethod = "";
                        }
                        queryString += "&sqladaptername=" + adapterName + "&sqlmethod=" + sqlmethod;

                        return ExternalSystemAPI.getSQLAdapters(self.externalSystemId, self.apiId, queryString).then(result => {
                            let responseData = {
                                totalCount: 0,
                                data: []
                            };
                            responseData.totalCount = result.recordsTotal;
                            if (result.data != null) {
                                responseData.data = result.data;
                                responseData.data.forEach(function (obj, index) {
                                    let actionsObj = {
                                        deploymentAction: {
                                            hidden: obj.deploymentTime == null
                                        }
                                    }
                                    obj['actions'] = actionsObj;
                                })
                            }
                            self.updateCallAdapter = true;
                            // self.fetchCall = false;
                            self.updateCallAdapter = true;
                            self.tableData = responseData.data;
                            return responseData;
                        });
                    } else {
                        self.filterActive = false;
                        let responseData = {
                            totalCount: self.filterData.length,
                            data: self.filterData
                        };
                        self.updateCallAdapter = true;
                        return responseData;
                    }
                },
                onAfterDataLoad: (start, limit) => {
                    self.updateAdaptersTemplate();
                }
            });
        },
        initFileAdaptersTable() {
            let self = this;
            self.updateCallAdapter = false;
            if (this.adaptersTableObj != null) {
                this.currentPageSize = this.adaptersTableObj.tableContext.store.state.pageSize;
            }
            const Table = document.querySelector('#adapterListTableTableId');
            this.adaptersTableObj = window.tableFactory.create(Table, {
                bordered: true,
                striped: true,
                emptyTemplate: '<p class="text-center m-0">No adapters found</p>',
                loadingTemplate: '<p class="text-center m-0">Loading...</p>',
                columnSearch: false,
                debounceTime: 1000,
                pageSize: self.currentPageSize,
                fixedHeight:true,
                schema: {
                    properties: {
                        name: {
                            type: "string",
                            title: "Name",
                            template: '<a class="name-link" data-id="{{id}}">{{name}}</a>',
                            sortable: true
                        }
                    }
                },
                data: (
                    start,
                    limit,
                    sortHeader,
                    sortDirection,
                    fullTextQuery,
                    searchColumns
                ) => {
                    if (!self.filterActives) {
                        self.updateCallAdapter = false;
                        if (self.adaptersTableObj != null) {
                            self.currentPageSize =
                                self.adaptersTableObj.tableContext.store.state.pageSize;
                        }
                        if (sortHeader == null) {
                            sortHeader = "name"
                        }
                        if (sortDirection == null) {
                            sortDirection = "asc"
                        }
                        let adapterName = self.filterName.trim();
                        let sqlmethod = self.selectedMethod.trim();
                        let queryString =
                            "start=" +
                            start +
                            "&length=" +
                            self.currentPageSize +
                            "&sort=" +
                            sortHeader +
                            "&dir=" +
                            sortDirection +
                            "&name=";
                        //self.protectedType;

                        if (adapterName == null) {
                            adapterName = "";
                        }

                        queryString += "&fileadaptername=" + adapterName;

                        return ExternalSystemAPI.getFileAdapters(self.externalSystemId, self.apiId, queryString).then(result => {
                            let responseData = {
                                totalCount: 0,
                                data: []
                            };
                            responseData.totalCount = result.page.totalElements;
                            if (result.data != null) {
                                responseData.data = result.data;
                                responseData.data.forEach(function (obj, index) {
                                    let actionsObj = {
                                        deploymentAction: {
                                            hidden: obj.deploymentTime == null
                                        }
                                    }
                                    obj['actions'] = actionsObj;
                                })
                            }
                            self.updateCallAdapter = true;
                            self.tableDatas = responseData.data;
                            // self.fetchCall = false;
                            return responseData;
                        });
                    } else {
                        self.filterActives = false;
                        let responseData = {
                            totalCount: self.filterData.length,
                            data: self.filterData
                        };
                        self.updateCallAdapter = true;
                        return responseData;
                    }
                },
                onAfterDataLoad: (start, limit) => {
                    self.updateAdaptersTemplate();
                }
            });
        },
        updateTemplate() {
            let self = this;
            this.$refs.connectionListTable
                .querySelectorAll('td [class="name-link"]')
                .forEach(btn => {
                    btn.addEventListener("click", e => {
                        let targetEle = e.target;
                        if (targetEle != null && self.adapterType == "File") {
                            let reference = $(targetEle).attr("data-id");
                            self.$router.push(
                                self.CONTEXT_PATH + "/integrate/externalsystems/" + self.externalSystemId + "/apis/" + self.apiId + "/file/" + reference
                            );

                        }
                        if (targetEle != null && self.adapterType == "REST") {
                            let restConnectionId = $(targetEle).attr("data-id");
                            self.$router.push(
                                self.CONTEXT_PATH + "/integrate/externalsystems/" + self.externalSystemId + "/apis/" + self.apiId + "/rest/" + restConnectionId
                            );

                        }

                        if (targetEle != null && self.adapterType == "Database") {
                            let dbConnectionId = $(targetEle).attr("data-id");
                            self.$router.push(
                                self.CONTEXT_PATH + "/integrate/externalsystems/" + self.externalSystemId + "/apis/" + self.apiId + "/database/" + dbConnectionId
                            );

                        }
                    });
                });
            $(".auth-link").each((a, obj) => {
                let authType = $(obj)[0].innerText;
                if (authType == 'NO_AUTH') {
                    $(obj).html("No authentication");
                } else if (authType == 'BASIC_AUTH') {
                    $(obj).html("Basic authentication");
                } else if (authType == 'API_KEY') {
                    $(obj).html("API token");
                } else if (authType == 'OAUTH_API_KEY') {
                    $(obj).html("OAuth 2.0 client credentials");
                } else if (authType == 'OAUTH_BASIC') {
                    $(obj).html("OAuth 2.0 password");
                }

            });

        },
        updateAdaptersTemplate() {
            let self = this;
            this.$refs.adapterListTable
                .querySelectorAll('td [class="name-link"]')
                .forEach(btn => {
                    btn.addEventListener("click", e => {
                        let targetEle = e.target;
                        if (targetEle != null) {
                            let reference = $(targetEle).attr("data-id");
                            localStorage.setItem("apiEditPageSize", self.adaptersPageSize);
                            localStorage.setItem(
                                "DataTables_" + window.location.pathname + "_filterName",
                                self.filterName
                            );
                            localStorage.setItem(
                                "DataTables_" + window.location.pathname + "_method-selectId",
                                self.selectedMethod
                            );
                            if (self.adapterType == "File") {
                                self.$router.push(
                                    self.CONTEXT_PATH + "/integrate/externalsystems/" + self.externalSystemId + "/apis/" + self.dto.id + "/fileadapters/" + reference.trim()
                                );
                            } else if (self.adapterType == "Database") {
                                self.$router.push(
                                    self.CONTEXT_PATH + "/integrate/externalsystems/" + self.externalSystemId + "/apis/" + self.dto.id + "/sqladapters/" + reference.trim()
                                );
                            } else if (self.adapterType == "REST") {
                                self.$router.push(
                                    self.CONTEXT_PATH + "/integrate/externalsystems/" + self.externalSystemId + "/apis/" + self.dto.id + "/restadapters/" + reference.trim()
                                );
                            }

                        }
                    });
                });

        },
        updateName(event) {
            let self = this;
            if (event.target.value == "") {
                displayErrorMessage($(self.$refs.name), constantMessages.MESSAGES["error.name.required"])
                self.$refs.name.classList.add("ms-is-invalid")
            } else if (event.target.value.length > 50) {
                displayErrorMessage($(self.$refs.name), constantMessages.MESSAGES["error.name.length"])
                self.$refs.name.classList.add("ms-is-invalid")

            } else if (!event.target.value.match(this.nameRegex)) {
                displayErrorMessage($(self.$refs.name), constantMessages.MESSAGES["error.name.invalid"])
                self.$refs.name.classList.add("ms-is-invalid")
            } else {
                self.$refs.name.classList.remove("ms-is-invalid")
            }
            self.dto.name = event.target.value;
        },
        closeDeleteDialog() {
            this.$refs.deleteExternalSystemAPI.close();
        },
        deleteExternalSystemAPI(e) {
            this.$refs.deleteExternalSystemAPI.close();
            let self = this;
            ExternalSystemAPI.deleteExternalSystemAPI(self.externalSystemId, self.apiId)
                .then(result => {
                    if (result != null) {
                        self.$router.push(
                            self.CONTEXT_PATH + "/integrate/externalsystems/" + self.externalSystemId
                        );
                        EventBus.$emit('success-notification', {
                            "msg": " External system API deleted successfully"
                        });
                        return;
                    }

                });
        },
        addAdapter() {
            let self = this;
            if (self.adapterType == "File") {
                self.$router.push(
                    self.CONTEXT_PATH + "/integrate/externalsystems/" + self.externalSystemId + "/apis/" + self.dto.id + "/fileadapters/new"
                );
            } else if (self.adapterType == "Database") {
                self.$router.push(
                    self.CONTEXT_PATH + "/integrate/externalsystems/" + self.externalSystemId + "/apis/" + self.dto.id + "/sqladapters/new"
                );
            } else if (self.adapterType == "REST") {
                self.$router.push(
                    self.CONTEXT_PATH + "/integrate/externalsystems/" + self.externalSystemId + "/apis/" + self.dto.id + "/restadapters/new"
                );
            }
        },
        addConnection() {
            let self = this;
            if (self.adapterType == "File") {
                self.$router.push(
                    self.CONTEXT_PATH + "/integrate/externalsystems/" + self.externalSystemId + "/apis/" + self.dto.id + "/file/new"
                );
            } else if (self.adapterType == "REST") {
                self.$router.push(
                    self.CONTEXT_PATH + "/integrate/externalsystems/" + self.externalSystemId + "/apis/" + self.dto.id + "/rest/new"
                );
            } else if (self.adapterType == "Database") {
                self.$router.push(
                    self.CONTEXT_PATH + "/integrate/externalsystems/" + self.externalSystemId + "/apis/" + self.dto.id + "/database/new"
                );
            }
        },
        exportFiles() {
            ImportExportAPI.exportFiles('EXTERNALSYSTEMAPI', this.apiId);
        },
        redirectToList() {
            localStorage.setItem("externalSystemList", "externalSystemList");

            this.$router.push(
                this.CONTEXT_PATH + '/integrate/externalsystems'
            );
        }
    }
};
</script>
